export const GET_SYMPTOM_SUCCESS = 'GET_SYMPTOM_SUCCESS'
export const GET_SYMPTOM_FAIL = 'GET_SYMPTOM_FAIL'
export const GET_SYMPTOM_CLEAR_DATA = 'GET_SYMPTOM_CLEAR_DATA'
